<!--
* @description  参数1
* @fileName  selectContact
* @author userName
* @date 2024-01-26 10:53:02
!-->
<template>
  <div id="selectContact" class="selectContact">
    <global-login-dialog v-model="isShow" @close="closeDialog">
      <template v-slot:title>
        <div class="title-first">选择地址</div>
      </template>
      <template v-slot:body>
        <div class="add-button" @click="addContact">
          <span>+</span> 新增
        </div>
        <div v-for="(item,index) in addressList" :key="index" class="contactItem">
          <div class="contactItem-l">
            <div class="contactItem-l-1">{{ item.companyName }}</div>
            <div class="contactItem-l-2">{{ item.name }}</div>
            <div class="contactItem-l-3">
              {{ item.cityName }},{{ item.provinceName }},{{ item.zipCode }},{{ item.countryCode }}
            </div>
          </div>
          <div class="contactItem-r">
            <div class="contactItem-edit" @click="eidtContact(item)">修改</div>
            <div class="contactItem-button">
              <button class="by-button--primary" @click="selectAddress(item)">选择</button>
            </div>
          </div>
        </div>

        <div v-if="isAddDialog" class="add-dialog">
          <ByForm ref="AddressForm" :button-name="&quot;Done&quot;" @save="addDone" @cencel="addCancel" />
        </div>
      </template>
    </global-login-dialog>

  </div>
</template>

<script>
import {
  GetCustomerAddress
} from '../../../../../../../api/user.js'
import {
  CreateOrderAddress,
  CheckOrderComplete
} from '../../../../../../../api/order.js'
import ByForm from './byForm.vue'
import GlobalLoginDialog from '../../../../../../../components/Dialog/Dialog.vue'
export default {
  name: 'SelectContact',
  components: {
    // 组件的引用
    GlobalLoginDialog,
    ByForm
  },
  props: {
    // 父辈向子辈传参
    isSelect: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      isShow: false,
      isAddDialog: false,
      orderData: {},
      addrType: undefined,
      addressList: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码

  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data, addrType) {
      this.isShow = true
	  this.isAddDialog = false
      this.orderData = data
      this.addrType = addrType
      var queryData = {
        addrType: this.addrType
      }
      if (this.addrType === 2) {
        queryData.city = this.orderData.startCityNameEn
      }
      GetCustomerAddress(queryData).then(res => {
        if (res.code === 200) {
          this.addressList = res.data
        }
      })
    },
    // 方法
    closeDialog() {
      document.getElementsByClassName('confirmOrder')[0].style.top = '80px'
      document.getElementsByClassName('confirmOrder')[0].style.overflow = 'auto'
      this.$emit('close', false)
    },
    addContact() {
      this.isAddDialog = true
      this.$nextTick(() => {
        this.$refs.AddressForm.init(this.orderData, this.addrType, undefined, true)
      })
    },
    eidtContact(item) {
      var data = item
      data.orderNo = this.orderData.orderNo
      data.addrType = this.addrType
      data.cusAddressId = item.id
      this.isAddDialog = true
      this.$nextTick(() => {
        this.$refs.AddressForm.init(this.orderData, this.addrType, data, true)
      })
    },
    addCancel() {
      this.isAddDialog = false
    },
    addDone() {
      this.isAddDialog = false
      this.init(this.orderData, this.addrType)
    },
    selectAddress(item) {
      var data = item
      data.provinceName = item.proviceName
      data.orderNo = this.orderData.orderNo
      data.addrType = this.addrType
      data.address = item.address1
      CreateOrderAddress(data).then(res => {
        if (res.code === 200) {
          this.isShow = false
          this.$emit('close')
          CheckOrderComplete(this.orderData.orderNo).then(res => {
		    if (res.code === 200 && res.data) {
		      this.$emit('next', res.data)
		    }
		  })
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.selectContact {
		position: relative;

		::v-deep .dialog {
			width: 848px;
			padding: 0 16px 1px;

			.dialog__header {
				text-align: left;
			}

			.dialog__body {
				padding: 0;
			}
		}

		.add-button {
			cursor: pointer;
			width: 848px;
			height: 40px;
			background: rgba(233, 85, 6, 0.04);
			border-radius: 8px;
			margin: 16px 0;
			line-height: 40px;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #E95506;
		}

		.contactItem {
			width: 816px;
			height: 116px;
			background: #FFFFFF;
			border-radius: 8px;
			border: 1px solid rgba(170, 170, 170, 0.24);
			padding: 0 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 16px;

			&:hover {
				border: 1px solid #AAAAAA;
			}

			.contactItem-l {
				text-align: left;

				.contactItem-l-1 {
					font-size: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
				}

				.contactItem-l-2 {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #333333;
					margin: 8px 0 12px 0px;
				}

				.contactItem-l-3 {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #777777;
				}
			}

			.contactItem-r {
				display: flex;
				align-items: center;

				.contactItem-edit {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #EF0A0A;
					cursor: pointer;
				}

				.contactItem-button {
					button {
						width: 80px;
						height: 32px;
						margin-left: 24px;
					}
				}
			}
		}

		.add-dialog {
			position: absolute;
			top: 128px;
			width: 816px;
			height: 472px;
			background: #FFFFFF;
			border-radius: 8px;
			border: 1px solid #777777;
			padding: 16px;
		}
	}
</style>
